import React from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { useLabels } from 'wsm-common-data';
import setFilters from '../actions/setFilters';
import { Filter } from './Filter';

export const Filters = ({ availableFilters }) => {
	const filters = useSelector((state) => state.filters);
	const dispatch = useDispatch();
	const labels = useLabels();
	const handleChange = (filterType, value) => {
		dispatch(
			setFilters({
				[filterType]: value
			})
		);
	};

	return (
		<form className="filters pb-0">
			<fieldset>
				<legend className="filters-label m-0 border-bottom-0 text-body ddc-font-size-base">
					{labels.get('FILTER_BY')}
				</legend>
				{availableFilters.map(({ type, values }) => (
					<Filter
						key={type}
						type={type}
						options={values}
						currentValue={filters[type]}
						handleChange={handleChange}
						labels={labels}
					/>
				))}
			</fieldset>
		</form>
	);
};
Filters.propTypes = {
	availableFilters: PropTypes.arrayOf(PropTypes.shape({})).isRequired
};
